import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

import { IChangeLaundryScheduleIntervalBody } from "types/laundry";

const useChangeLaundryScheduleIntervalMutation = () => {
  return useMutation(async (data: IChangeLaundryScheduleIntervalBody) => {
    try {
      const res = await laundriesService.changeLaundryScheduleInterval(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useChangeLaundryScheduleIntervalMutation